import dayjs, { Dayjs } from 'dayjs';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import relativeTime from 'dayjs/plugin/relativeTime';

export const getDisplayDate = (date: Dayjs): string => {
    // if (date.diff(dayjs(), 'days') < -7) return date.format('M-D-YY');
    return date.fromNow();
};
